import React, { useEffect, useRef } from 'react'
import { Flex, Icon, Heading, Text, Button, Theme, useIsTheme } from '@afterpaytouch/core'
import clsx from 'clsx'
import { CheckoutPage } from '../../model'
import { useTranslation } from '../../utils/convergence'
import styles from './styles.module.css'
import { useCheckoutSizes } from '../../utils/responsive'
import { TrackPageViewed } from '../../integrations/monitoring'
import { useCloseCheckout } from '../../utils/close'
import { useIsAppleRetailAppleStoreAppOrder, useSendEndTransactionMessage } from '../../state'

export const PurchaseSuccessPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const { headingSize, textSize } = useCheckoutSizes()
  const isKelpie = useIsTheme(Theme.Kelpie)
  const isKelpieMint = useIsTheme(Theme.KelpieMint)
  const isKelpieFamily = isKelpie || isKelpieMint

  const sendEndTransactionMessage = useSendEndTransactionMessage() ?? true

  const closeRef = useRef(useCloseCheckout())
  const sendEndTransactionMessageRef = useRef(sendEndTransactionMessage)
  const isAppleStoreAppOrderRef = useRef(useIsAppleRetailAppleStoreAppOrder())

  useEffect(() => {
    void closeRef.current(sendEndTransactionMessageRef.current)
  }, [])

  const handleReturn = (): void => {
    void closeRef.current(sendEndTransactionMessageRef.current)
  }

  const subtitle = isAppleStoreAppOrderRef.current ? t('purchaseSuccess:subtitleAppleStoreApp') : t('purchaseSuccess:subtitle')
  const buttonLabel = isAppleStoreAppOrderRef.current ? t('purchaseSuccess:openAppleStoreAppButton') : t('purchaseSuccess:returnToMerchant')

  return (
    <>
      <Flex direction='column'>
        <Flex alignItems='center' justifyContent='center' className={clsx(styles.iconWrapper, isKelpieFamily && styles.iconWrapperKelpie)}>
          <Icon name='Check' size='Medium' color={isKelpieFamily ? 'Black' : 'White'} />
        </Flex>
        <Heading size={headingSize} className={styles.heading}>
          {t('purchaseSuccess:heading')}
        </Heading>
        <div className={styles.subtitle}>
          <Text size={textSize} color='Gray50'>
            {subtitle}
          </Text>
        </div>
        <Button kind='Secondary' padding='Fluid' onClick={handleReturn}>
          {buttonLabel}
        </Button>
      </Flex>
      <TrackPageViewed />
    </>
  )
}
